export const baseComponentOverrides = {
    MuiButtonBase: {
        defaultProps: {
            disableRipple: true
        }
    },
    MuiButtonGroup: {
        defaultProps: {
            disableRipple: true
        }
    },
    MuiScopedCssBaseline: {
        styleOverrides: {
            root: {
                fontSize: '1rem'
            }
        }
    }
};
